var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('original-button',_vm._g(_vm._b({attrs:{"icon":_vm.icon ? ("ti-" + _vm.icon) : ''}},'original-button',_vm.$attrs,false),_vm.allListeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }